import { render } from "./TableEmptyState.vue?vue&type=template&id=00ed16b2"
import script from "./TableEmptyState.vue?vue&type=script&lang=js"
export * from "./TableEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__